import './utils/productionConsole';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { BrowserRouter as Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import './i18n';
import './assets/fonts/vazir.css';
import './assets/fonts/arshia.css';
import './assets/styles/style.css';

// Generate global key for entities
let key = 0;
window.$_getEntityKey = () => {
  return key++;
};

// if (dir === 'ltr') {
//   require('./assets/styles/styleLTR.scss');
// } else {
//   require('./assets/styles/styleRTL.scss');
// }

document.documentElement.dataset.theme = 'dark';

// Configure redux store
const preloadedState = {};
const store = configureStore(preloadedState);

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
